import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';

import { useCurrentActor } from 'components/contexts/CurrentActor';
import { useTrainingRegisterResources } from 'components/contexts/TrainingRegisterResourceManagementContext';
import PersonnelTeamSelect from 'components/personnel/PersonnelTeamSelect';
import PersonnelTypeFilters from 'components/personnel/PersonnelTypeFilters';
import TrainingStatusChart from 'components/personnel/TrainingStatusChart';
import TrainingStatusFilter from 'components/personnel/TrainingStatusFilter';

export default function PersonnelFilter({
  isDisabled,
  personnelTypeFilters,
  scopedCount,
  teamFilter,
  totalCount,
  trainingStatusCounts,
  trainingStatusFilters,
}) {
  const currentActor = useCurrentActor();

  const { hasSubcontractorPersonnelViewableAccess, hasTeamViewableAccess } =
    useTrainingRegisterResources();

  return (
    <div className='col-sm-3 tw-pl-0'>
      <div className='filter-container tw-border-grey-100 tw-bg-white tw-pb-3'>
        <div
          className={classNames(
            hasTeamViewableAccess ?
              'filter-container__header--lg'
            : 'filter-container__header',
          )}
        >
          {hasTeamViewableAccess && (
            <div className={classNames(hasTeamViewableAccess && 'tw-mb-8')}>
              <PersonnelTeamSelect
                filter={teamFilter.filter}
                onOptionChange={teamFilter.onChange}
              />
            </div>
          )}
          {currentActor.isAllowedFeature('training_register') ?
            <TrainingStatusChart
              scopedCount={scopedCount}
              statusCounts={trainingStatusCounts}
              totalCount={totalCount}
            />
          : <div className='filter-container__block tw-bg-grey-050'>
              <Trans
                components={{
                  h3: (
                    /* eslint-disable-next-line jsx-a11y/heading-has-content */
                    <h3 className='filter-container__info tw-text-3xl tw-font-semibold tw-tracking-tighter tw-text-grey-900' />
                  ),
                  p: <p className='filter-container__sub-info' />,
                }}
                i18nKey='personnel.countOfTotalCount'
                ns='common'
                values={{ count: scopedCount, totalCount }}
              />
            </div>
          }
        </div>
        {currentActor.isAllowedFeature('training_register') && (
          <div className='filter-container__content'>
            <TrainingStatusFilter
              filters={trainingStatusFilters.filters}
              isDisabled={isDisabled}
              onChange={trainingStatusFilters.onChange}
              statusCounts={trainingStatusCounts}
            />
          </div>
        )}
        {hasSubcontractorPersonnelViewableAccess && (
          <div>
            {currentActor.isAllowedFeature('training_register') && (
              <hr className='tw-m-0 tw-h-px tw-border-0 tw-bg-grey-100' />
            )}
            <div className='filter-container__content'>
              <PersonnelTypeFilters
                filters={personnelTypeFilters.filters}
                isDisabled={isDisabled}
                onChange={personnelTypeFilters.onChange}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

PersonnelFilter.propTypes = {
  isDisabled: PropTypes.bool,
  personnelTypeFilters: PropTypes.object.isRequired,
  scopedCount: PropTypes.number.isRequired,
  teamFilter: PropTypes.object.isRequired,
  totalCount: PropTypes.number.isRequired,
  trainingStatusCounts: PropTypes.object.isRequired,
  trainingStatusFilters: PropTypes.object.isRequired,
};

PersonnelFilter.defaultProps = {
  isDisabled: false,
};
